export const getCurrentBookings = state => state.bookings.bookings;
export const claimBookingStatus = state => state.bookings.status;
export const getPaginationBooking = state => state.bookings.pagination;
export const getReserveShown = state => state.bookings.reserveShown;
export const getCheckinShown = state => state.bookings.checkinShown;
export const getCheckoutShown = state => state.bookings.checkoutShown;
export const getClaimedShown = state => state.bookings.claimedShown;
